export default "__VITE_ASSET__CAsGZrrQ__"